/**
 * 公共接口
 */
import http from '../http';
import Qs from 'qs';

// 资源管理

// 上传文件
const uploadCourse = (params) =>
  http
    .post('/theUserIdentity/courseDefine/uploadCourse', { params })
    .then((res) => res.data);

// 平台资源管理-分页
const getClassCoursePage = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getCoursePage', { params })
    .then((res) => res.data);
// 机构端 - 获取学校课程分类 v1.3.1
const getCourseTypeDefinePage = (params) =>
  http
    .get('/theUserIdentity/courseClass/serachCourseDefine', { params })
    .then((res) => res.data);

// 资源上架管理-分页
const getCoursePutAwayPage = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getCoursePutAwayPage', { params })
    .then((res) => res.data);

// 删除资源管理课程
const deleteCourse = (params) =>
  http
    .delete('/theUserIdentity/courseDefine/deleteCourse', {
      params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);

// 上架
const putCourse = (params) =>
  http
    .post('/theUserIdentity/courseDefine/putCourse', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 课程商品
// 获取课程商品列表查询
const getgoodsTableList = (params) =>
  http
    .get('/theUserIdentity/courseClass/listByCondition', { params })
    .then((res) => res.data);

// 获取学校列表  运营端,教育局
const getgoodSchoolList = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);

// 获取学校列表  机构端
const getMechanismSchoolList = (params) =>
  http.get('/schoolOrgRel/orgSchoolName', { params }).then((res) => res.data);

// 获取校区列表
const getgoodAreaList = (params) =>
  http.get('/sysSchools/listAll', { params }).then((res) => res.data);

// 获取课程商品搜索框学期列表
const getyearTermsList = (params) =>
  http.get('/yearTerms/schoolTerms', { params }).then((res) => res.data);
// 获取课程商品搜索框学期列表 -- 新 2022-15-19   新增 时间区间
const getyearTermsListByNew = (params) =>
  http.get('/dataSearch/searchTerm', { params }).then((res) => res.data);

// 获取课程商品搜索框课程分类列表
const getcourseTypeList = (params) =>
  http.get('/courseType/courseTypeList', { params }).then((res) => res.data);

// 获取课程商品搜索框提供方列表
const getListCourseOrder = (params) =>
  http.get('/courseClass/listCourseOrder', { params }).then((res) => res.data);

// 获取学期列表
const getListTerms = (params) =>
  http.get('/yearTerms/listTerms', { params }).then((res) => res.data);

// 获取机构下面的学校
const getOrgSchoolListNew = (params) =>
  http
    .get('/schoolOrgRel/pageOrgSchoolName', { params })
    .then((res) => res.data);

// 获取提供方
const getCourseProviderList = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getCourseProviderList', { params })
    .then((res) => res.data);
// 新的提供方  新
const getNewCourseProviderList = (params) =>
  http
    .get('/theUserIdentity/courseClass/serachProvider', { params })
    .then((res) => res.data);
// 上架学校（教育局）
const getSchoolNameListByedu = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);
// 上架学校（机构）
const getSchoolNameListByService = (params) =>
  http.get('/sysOrganizations/getRelSchool', { params }).then((res) => res.data);
// 上架学校（运营）
const getSchoolNameListByOperate = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);

// 批量修改课程商品
const batchUpdateGood = (params) =>
  http
    .post('/theUserIdentity/courseClass/batchUpdate', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除课程商品
const deleteCourseClass = (params) =>
  http
    .post('/theUserIdentity/courseClass/delete', Qs.stringify(params))
    .then((res) => res.data);

// 课程商品导出Excel
const exportByCondition = (params) =>
  http
    .get('/theUserIdentity/courseClass/exportByCondition', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 查询分类
const getCourseTypeTapList = (params) =>
  http
    .post(
      '/theUserIdentity/courseTypeDefine/getCourseTypeTapList',
      Qs.stringify(params)
    )
    .then((res) => res.data);

// 开班失败发送短信
const getCloseCourseClassmsg = (params) =>
  http
    .post('/theUserIdentity/courseClass/closeCourseClass/msg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 开班失败退款
const getCloseCourseClassRefund = (params) =>
  http
    .post('/theUserIdentity/UserOrder/batchRefund', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 课程商品下载导入模板 -- 运营端
const exportByloadCilTemplate = (params) =>
  http
    .get('/theUserIdentity/courseClass/downloadTemplate', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程商品下载导入模板 -- 学校端
const exportByloadCilTemplateBySchool = (params) =>
  http
    .get('/school/courseClass/downloadTemplate', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程商品下载导入模板 -- 机构端
const exportByloadCilTemplateByOrg = (params) =>
  http
    .get('/org/courseClass/downloadTemplate', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 批量导入课程商品 -- 运营端
const importCourseClass = (params) =>
  http
    .post(`/theUserIdentity/courseClass/importCourseClass`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data);
// 批量导入课程商品 - 学校端
const importCourseClassBySchool = (params) =>
  http
    .post(`/school/courseClass/importCourseClass`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data);
// 批量导入课程商品 - 机构端
const importCourseClassByOrg = (params) =>
  http
    .post(`/org/courseClass/importCourseClass`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data);
// 获取学年列表
const getDataSearchYearList = (params) =>
  http.get('/dataSearch/getYearList', { params }).then((res) => res.data);

// 子课程商品查询
const getSubProductPage = (params) =>
  http
    .get('/theUserIdentity/courseClassCombos/subProductPage', { params })
    .then((res) => res.data);
// 子课程商品查询 学校端
const getSubProductPageBySch = (params) =>
  http
    .get('/school/courseClassCombos/subProductPage', { params })
    .then((res) => res.data);
// 保存商品套餐
const saveProductPackage = (params) =>
  http
    .post('/theUserIdentity/courseClassCombos/saveProductPackage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 保存商品套餐 学校端
const saveProductPackageBySch = (params) =>
  http
    .post('/school/courseClassCombos/saveProductPackage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 编辑商品套餐
const updateProductPackage = (params) =>
  http
    .post('/theUserIdentity/courseClassCombos/updateProductPackage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 编辑商品套餐
const updateProductPackageBySch = (params) =>
  http
    .post('/school/courseClassCombos/updateProductPackage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 子课程商品查询
const getProductPackagePage = (params) =>
  http
    .get('/theUserIdentity/courseClassCombos/productPackagePage', { params })
    .then((res) => res.data);
// 课程套餐查询 -- 学校端
const getProductPackagePageBySch = (params) =>
  http
    .get('/school/courseClassCombos/productPackagePage', { params })
    .then((res) => res.data);

// 商品套餐详情查询
const getProductPackageDetail = (params) =>
  http
    .get('/theUserIdentity/courseClassCombos/productPackageDetail', { params })
    .then((res) => res.data);
// 服务管理-学校管理-删除
const deleteProductPackage = (params) =>
  http
    .delete('/theUserIdentity/courseClassCombos/deleteProductPackage', {
      params
    })
    .then((res) => res.data);
// 服务管理-学校管理-删除 学校端
const deleteProductPackageBySch = (params) =>
  http
    .delete('/school/courseClassCombos/deleteProductPackage', {
      params
    })
    .then((res) => res.data);

// 教务人员管理分页查询
const getAcademicStaffApi = (params) =>
  http
    .get('/theUserIdentity/academicStaff/page', { params })
    .then((res) => res.data);
// 教务人员管理分页查询
const saveAcademicStaffApi = (params) =>
  http
    .post('/theUserIdentity/academicStaff/updateAcademicStaff', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 根据学期id获取日期范围
const getTimeScope = (params) =>
  http
    .get('/theUserIdentity/classroomSign/getTimeScope', { params })
    .then((res) => res.data);
// 课程资源导出-
const getCourseDefineExport = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getCourseDefineExport', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 值班老师更新
const updateDutyTeacherApi = (params) =>
  http
    .post('/theUserIdentity/academicStaff/updateDutyTeacher', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 值班老师新增
const addDutyTeacherApi = (params) =>
  http
    .post('/theUserIdentity/academicStaff/addDutyTeacher', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 学生请假可退款分页查询
const pageLeaveCanRefund = (params) =>
  http
    .get('/theUserIdentity/leave/pageLeaveCanRefund', {
      params
    })
    .then((res) => res.data);

// 学生请假可退款数据统计
// const leaveCanRefundStat = (params) =>
//   http
//     .get('/theUserIdentity/leave/leaveCanRefundStat', {
//       params
//     })
//     .then((res) => res.data)

const leaveCanRefundStat = (params) =>
  http
    .post('/theUserIdentity/leave/leaveCanRefundStat', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 学生请假列表-数据统计
const studentLeaveStat = (params) =>
  http
    .get('/theUserIdentity/leave/studentLeaveStat', {
      params
    })
    .then((res) => res.data);

// 商品套餐导出
const productPackageExport = (params) =>
  http
    .get('/theUserIdentity/courseClassCombos/productPackageExport', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 更新套餐商品上架时间
const updateComboSortTime = (params) =>
  http
    .post('/theUserIdentity/courseClass/updateSortTime', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 材料商品-分页查询
const getCourseClassMaterialPage = (params) =>
  http
    .get('/theUserIdentity/courseClassMaterial/getCourseClassMaterialPage', {
      params
    })
    .then((res) => res.data);
// 根据材料商品id更新是否可见
const updateIsVisible = (params) =>
  http
    .get('/theUserIdentity/courseClassMaterial/updateIsVisible', {
      params
    })
    .then((res) => res.data);
// 材料商品-导出
const courseClassMaterialExport = (params) =>
  http
    .get('/theUserIdentity/courseClassMaterial/courseClassMaterialExport', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

export default {
  pageLeaveCanRefund,
  leaveCanRefundStat,
  studentLeaveStat,
  getListCourseOrder,
  getgoodSchoolList,
  getMechanismSchoolList,
  getClassCoursePage,
  getCourseTypeDefinePage,
  getListTerms,
  getgoodsTableList,
  getgoodAreaList,
  getyearTermsList,
  getyearTermsListByNew,
  batchUpdateGood,
  getcourseTypeList,
  uploadCourse,
  deleteCourseClass,
  exportByCondition,
  getCoursePutAwayPage,
  deleteCourse,
  putCourse,
  getCourseProviderList,
  getNewCourseProviderList,
  getOrgSchoolListNew,
  getSchoolNameListByedu,
  getSchoolNameListByService,
  getSchoolNameListByOperate,
  getCourseTypeTapList,
  getCloseCourseClassmsg,
  getCloseCourseClassRefund,
  exportByloadCilTemplate,
  exportByloadCilTemplateBySchool,
  exportByloadCilTemplateByOrg,
  importCourseClassBySchool,
  importCourseClassByOrg,
  importCourseClass,
  getDataSearchYearList,
  getSubProductPage,
  getSubProductPageBySch,
  saveProductPackage,
  getProductPackagePage,
  getProductPackagePageBySch,
  getProductPackageDetail,
  updateProductPackage,
  deleteProductPackage,
  deleteProductPackageBySch,
  updateProductPackageBySch,
  saveProductPackageBySch,
  getAcademicStaffApi,
  saveAcademicStaffApi,
  getTimeScope,
  getCourseDefineExport,
  updateDutyTeacherApi,
  addDutyTeacherApi,
  productPackageExport,
  updateComboSortTime,
  getCourseClassMaterialPage,
  updateIsVisible,
  courseClassMaterialExport
};
